<template>
  <div id="app">

    <div v-show="$store.state.DLINE_ENVIRONMENT" id="devenvironment_warning" style="position:fixed;z-index:10000;top:0;width:100px;margin-left:-50px;left:50%;background-color:#ffb734;text-align:center;padding:10px;border-radius:0 0 4px 4px;opacity:.5;font-weight:bold;pointer-events:none;">{{$store.state.DLINE_ENVIRONMENT}}</div>
    <keep-alive :include="['SearchSet', 'RetiringSoon', 'LandmarkMap']">
    <!-- 需要缓存的视图组件 -->
      <!-- <transition :name="transitionName"> -->
        <router-view v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
      <!-- </transition> -->
    </keep-alive>
    <!-- 不需要缓存的视图组件 -->
    <transition :name="transitionName">
      <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
    </transition>
 
    <!-- <transition :name="transitionName">
      <keep-alive>
        <router-view v-if="isRouterAlive"></router-view>
      </keep-alive>
    </transition> -->

  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      pageReload: this.pageReload
    }
  },
  data() {
    return {
      isRouterAlive: true,//协助无感刷新页面
      transitionName: 'slide-left',
    };
  },
  watch: {
    '$route': {
      handler(to, from){

        // console.log(document.URL, location.href, document.referrer);

        // console.log("to", to);
        // console.log("from", from);
        // console.log("document.referrer", document.referrer);
        if(this.$store.state.browser.ios) {
          if(from && to.name == 'Index' && from.name == null && from.path == '/') {

          }
        }

        //console.log(this.$store.state.browser);
        if(this.$store.state.browser.ios && this.$store.state.browser.giantapp){
          if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'; //改为manual之后，就不会记录滚动位置
          }
        }


        // 通过判断路由自定义的级别来判断是转入还是转出
        // if (to && from && to.meta.index > from.meta.index) {
        //   this.transitionName = "slide-left";
        // } else {
        //   this.transitionName = "slide-right";
        // }

        // console.log("from:", from);
        // console.log("to:", to);
/*
        if ( to && from ) {
          if( !from.name && to.name == 'Index' ){
            this.transitionName = '';
          } else {
            if( to.name == 'SearchSet' ){//目标页是搜索套组

              if( from.name == 'SetIndex' || from.name == 'SetIndexById' ){
                this.transitionName = 'slide-right';//后退
              } else {
                this.transitionName = 'slide-left';//前进
              }

            } else {//目标页不是搜索套组

              //if( to.name == from.name ){
                if (parseInt(to.query._t) < parseInt(from.query._t)) {
                  this.transitionName = 'slide-right';
                } else {
                  this.transitionName = 'slide-left';
                }
              // } else {
              //   if (to.meta.index > from.meta.index) {
              //     this.transitionName = 'slide-left';//前进
              //   } else {
              //     this.transitionName = 'slide-right';//后退
              //   }
              // }

            }


          }
        } else {
          //this.transitionName = 'slide-right';//后退
          this.transitionName = '';
        }
*/


        if ( to && from ) {
          if( !from.name ){// && to.name == 'Index'
            this.transitionName = '';
          } else {

              if(
                (from.name == "Index" && to.name == "IndexTheme") ||
                (from.name == "Index" && to.name == "IndexBrand") ||
                (from.name == "IndexTheme" && to.name == "Index") ||
                (from.name == "IndexTheme" && to.name == "IndexBrand") ||
                (from.name == "IndexBrand" && to.name == "Index") ||
                (from.name == "IndexBrand" && to.name == "IndexTheme")
              ){
                this.transitionName = '';
              } else if( to.name == "Index" || to.name == "IndexTheme" || to.name == "IndexBrand" ){
                this.transitionName = 'slide-right';//后退
              } else if( to.name == from.name || ( from.name == 'SetIndex' || to.name == 'SetIndexById' ) || ( to.name == 'SetIndex' || from.name == 'SetIndexById' ) ){
                //console.log(to);
                //console.log(from);
                if (parseInt(to.query._t) < parseInt(from.query._t)) {
                  this.transitionName = 'slide-right';
                } else {
                  this.transitionName = 'slide-left';
                }
              } else {
                if (to.meta.index > from.meta.index) {
                  this.transitionName = 'slide-left';//前进
                } else {
                  this.transitionName = 'slide-right';//后退
                }
              }

          }
        } else {
          //this.transitionName = 'slide-right';//后退
          this.transitionName = '';
        }




        //console.log("transitionName:", this.transitionName);

      },
      immediate: true,//首次进入页面即执行
    },
  },
  methods: {
    pageReload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
        this.isRouterAlive = true;
        this.transitionName = '';
      });
    }
  }
}
</script>

<style>

/*
    动画样式
    will-change: transform    优化渲染速度
*/

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.5s;
  width: 100%;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

</style>



// WEBPACK FOOTER //
// src/App.vue